import React from "react";
import { Link } from "react-router-dom";

const DropBtn = () => {
  return (
    <div className="flex flex-col shadow-lg font-bold  drop-btn">
      <ul className="flex flex-col gap-2 text-xs text-center">
        <li className="border-gray-400 pb-2 border-b">
          <Link to="/virtualaccounts/energy">Energy</Link>
        </li>
        <li>
          <Link to='/virtualaccounts/cable'>Cable</Link>
        </li>
      </ul>
    </div>
  );
};

export default DropBtn;
